import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Popover} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import extract from '../../core/extract'
import phonez from '../../core/phonez'
import LoaderButton from '../../core/components/LoaderButton'
import ContactPicker from './ContactPicker'
import {LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED, sendLinkPatrimonyContactWithCmd, updateLinkPatrimonyContactWithCmd, loadPatrimony, loadLot, loadContactStream} from '../actions'
import {CONTACT_PATRIMONY_LINK_TYPES, CONTACT_LOT_LINK_TYPES, HOME_OWNER_ASSOCIATION_POSITIONS, LinkPatrimonyContactWithCmd} from '../models'
import i18n from '../i18n'

function restrict(allowed, value) {
    if (value) return allowed.indexOf(value) >= 0 && value || allowed[0]
    return allowed[0]
}

class LinkPatrimonyContactWithPopover extends Component {

    static propTypes = {
        patrimony: PropTypes.object,
        lot: PropTypes.object,
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {dispatch, cmd, patrimony, lot} = this.props

        const linkTypes = (patrimony && CONTACT_PATRIMONY_LINK_TYPES) || (lot && CONTACT_LOT_LINK_TYPES)
        const linkType = restrict(linkTypes, cmd && cmd.linkedWith && cmd.linkedWith.linkType)

        this.setState({linkTypes})

        dispatch(updateLinkPatrimonyContactWithCmd({
            linkedWith: {
                ...(cmd && cmd.linkedWith),
                lotUid: lot && lot.uid,
                patrimonyUid: patrimony && patrimony.uid,
                linkType: linkType
            }
        }))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.patrimony != this.props.patrimony
            || nextProps.lot != this.props.lot) {
            const {dispatch, cmd, patrimony, lot} = nextProps

            const linkTypes = (patrimony && CONTACT_PATRIMONY_LINK_TYPES) || (lot && CONTACT_LOT_LINK_TYPES)
            const linkType = restrict(linkTypes, cmd && cmd.linkedWith && cmd.linkedWith.linkType)

            this.setState({linkTypes})

            dispatch(updateLinkPatrimonyContactWithCmd({
                linkedWith: {
                    ...(cmd && cmd.linkedWith),
                    lotUid: lot && lot.uid,
                    patrimonyUid: patrimony && patrimony.uid,
                    linkType: linkType
                }
            }))
        }
    }

    _sendCmd() {
        const {dispatch, patrimony, lot, onHide} = this.props
        const {contact} = this.state

        return dispatch(sendLinkPatrimonyContactWithCmd(contact.uid)).then(() => {
            return Promise.all([
                patrimony && dispatch(loadPatrimony()),
                lot && dispatch(loadLot()),
                dispatch(loadContactStream())
            ])
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, onHide, form, cmd, patrimony, lot, ...others} = this.props
        const {linkTypes, contact} = this.state

        const contactField = () => {
            const value = contact

            const onChange = (contact) => {
                this.setState({contact})
            }

            return {value, onChange}
        }

        const displayContact = (contact, mode) => {
            const phoneMedium = contact.contacts.find((c) => c.contactInfoType == 'Phone')

            if (mode == 'Picked') {
                return (
                    <div>
                        <h4>
                            <span>{contact.name.firstName}</span>
                            <span> {contact.name.lastName}</span>
                            <span>{contact.name.value}</span>
                            {phoneMedium && (
                                <span> ({phonez(phoneMedium.phone).format()})</span>
                            )}
                        </h4>
                        <form className='form-horizontal'>
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='select'
                                name='linkType'
                                label={i18n.patrimonyContactLinkType}
                                {...form.linkedWith.linkType()}>
                                <option value=''></option>
                                {linkTypes.map((linkType, index) => (
                                    <option
                                        key={index}
                                        value={linkType}>
                                        {extract(i18n.patrimonyContactLinkTypeEnum, linkType)}
                                    </option>
                                ))}
                            </Input>
                            {form.linkedWith.position && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='select'
                                    name='position'
                                    label={i18n.homeOwnerAssociationPosition}
                                    {...form.linkedWith.position()}>
                                    <option value=''></option>
                                    {HOME_OWNER_ASSOCIATION_POSITIONS.map((position, index) => (
                                        <option
                                            key={index}
                                            value={position}>
                                            {extract(i18n.homeOwnerAssociationPositionEnum, position)}
                                        </option>
                                    ))}
                                </Input>
                            )}
                        </form>
                    </div>
                )
            }

            return (
                <span>
                    <span>{contact.name.firstName}</span>
                    <span> {contact.name.lastName}</span>
                    <span>{contact.name.value}</span>
                    {phoneMedium && (
                        <span> ({phonez(phoneMedium.phone).format()})</span>
                    )}
                </span>
            )
        }

        return (
            <Popover
                bsClass='popover-lg popover'
                title={i18n.linkPatrimonyContact}
                {...others}>
                <ContactPicker
                    patrimony={patrimony || (lot && lot.patrimony)}
                    display={displayContact}
                    {...contactField()} />
                <ButtonToolbar>
                    <LoaderButton
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !contact || !form.isValid()})}
                        onClick={() => (contact && form.validate()) && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.save}
                    </LoaderButton>
                    <Button
                        bsSize='large'
                        onClick={onHide}>
                        {i18n.cancel}
                    </Button>
                </ButtonToolbar>
            </Popover>
        )
    }
}

LinkPatrimonyContactWithPopover = connectForm({
    target: 'cmd',
    schema: LinkPatrimonyContactWithCmd.selectSchema,
    action: LINK_PATRIMONY_CONTACT_WITH_CMD_UPDATED
})(LinkPatrimonyContactWithPopover)

LinkPatrimonyContactWithPopover = connect((state) => ({
    cmd: state.patrimony.linkPatrimonyContactWithCmd
}))(LinkPatrimonyContactWithPopover)

export default LinkPatrimonyContactWithPopover


// WEBPACK FOOTER //
// ./lib/patrimony/components/LinkPatrimonyContactWithPopover.js